import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import CustomInput from "../inputs/CustomInput";
import CustomButton from "../Buttons/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { investSchema } from "../../Helper/validationSchemas";
import SelectField from "../inputs/SelectField";
import { _countries } from "../../config/data";

import ConfirmInvest from "./ConfirmInvest";
import { investmentForUser } from "../../store/actions/investment/investment";

const InvestForUser = ({ open, onClose, cycle, investment, userId }) => {
  const dispatch = useDispatch();

  const [showVerification, setShowVerification] = useState(false);

  const handleSubmit = (values, { setSubmitting }) => {
    const payload = {
      id: userId,
      data:
        investment?.investment_category?.slug === "property"
          ? {
              investment_product_id: investment?.id,
              investment_type: investment?.investment_category?.slug,
              unit: values?.unit,

              payment_type: "transfer",

              amount: values.amount,
              admin_charges: values.fees,
              debit_amount:
                values.status?.value == 0
                  ? 0
                  : Number(values.amount) + Number(values.fees),
            }
          : {
              investment_product_id: investment?.id,
              investment_type: "business",

              cycle_id: cycle?.id,
              payment_type: "transfer",

              amount: values.amount,
              admin_charges: values.fees,
              debit_amount:
                values.status?.value == 0
                  ? 0
                  : Number(values.amount) + Number(values.fees),
            },
      failed: () => {
        setSubmitting(false);
      },
      cb: () => {
        setSubmitting(false);
        onClose();
      },
    };

    dispatch(investmentForUser(payload));
  };

  const form = useFormik({
    initialValues: {
      amount: "",
      currency: {
        value: cycle?.currency || investment?.currency,

        label: cycle?.currency || investment?.currency,
      },
      unit: "",

      fees: "",
      status: { value: "1", label: "YES" },
    },
    validationSchema: investSchema,
    onSubmit: handleSubmit,
  });

  const handleVerifyInvest = () => {
    form.resetForm();
    onClose();
  };

  return showVerification ? (
    <ConfirmInvest
      loading={form?.isSubmitting}
      open={showVerification}
      submit={form.handleSubmit}
      onClose={() => setShowVerification(false)}
    />
  ) : (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          maxHeight: "80%",
          overflowY: "scroll",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            top: 19,
            right: 10,
          }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-5" style={{ padding: "10px 20px" }}>
          <img
            src="/Assets/approveIcon.png"
            alt=""
            className="w-12 h-12 mb-5"
          />
          <div className="w-full  my-2">
            <label className="text-sm font-[600] text-[#344054]">
              Debit User's Wallet
            </label>
            <div className="w-full mb-4">
              <SelectField
                // label=" Debit User's Wallet"
                id="status"
                form={form}
                options={[
                  { value: "1", label: "YES" },
                  { value: "0", label: "No" },
                ]}
                sx={{ width: "100%", height: "50px" }}
              />
            </div>

            {investment?.investment_category?.slug === "property" ? (
              <>
                {" "}
                <label className="text-sm font-[600] text-[#344054]">
                  Unit
                </label>
                <div className="w-full mb-4">
                  <CustomInput
                    // width="400px"
                    fullWidth
                    height="18px"
                    id="unit"
                    type="number"
                    form={form}
                    placeholder={"Enter amount"}
                    borderColor="#D0D5DD"
                    mt="10px"
                    pt="28px"
                  />
                </div>
              </>
            ) : (
              <></>
            )}
            <label className="text-sm font-[600] text-[#344054]">Amount</label>
            <div className="w-full mb-4">
              <CustomInput
                // width="400px"
                fullWidth
                height="18px"
                id="amount"
                type="currency"
                form={form}
                placeholder={"Enter amount"}
                borderColor="#D0D5DD"
                mt="10px"
                pt="28px"
              />
            </div>
            <label className="text-sm font-[600] text-[#344054]">
              Admin fee
            </label>
            <div className="w-full mb-4">
              <CustomInput
                // width="400px"
                fullWidth
                height="18px"
                id="fees"
                type="currency"
                form={form}
                placeholder={"Enter admin fee"}
                borderColor="#D0D5DD"
                mt="10px"
                pt="28px"
              />
            </div>
            {/* {showOtp && (
              <OTPInput
                value={otp}
                onChange={setOtp}
                inputType="password"
                numInputs={6}
                renderInput={(props) => <input {...props} />}
                placeholder="----"
                containerStyle={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "34px",
                  marginBottom: "18px",
                }}
                inputStyle={{
                  width: "50px",
                  height: "50px",
                  border: "1.5px solid #159AA8",
                  borderRadius: "10px",
                  fontWeight: "bold",
                  color: "#159AA8",
                  fontSize: "20px",
                  marginLeft: "6px",
                  marginRight: "6px",
                }}
              />
            )} */}

            <div className="flex w-full  items-center">
              <CustomButton
                variant="contained"
                customColor="#159AA8"
                children="Continue"
                width="100%"
                height="45px"
                disabled={!form?.dirty || !form?.isValid}
                padding="10px"
                margin="15px 0"
                color="#fff"
                onClick={() => setShowVerification(true)}
              />
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default InvestForUser;
